// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

const regions = ['AMER', 'EMEA', 'APAC'];
const regionDefault = 'AMER';
const regionEvent = 'Region Set';

export function populateDataLayer(region: string | null) {
    if (region) {
        region = region.toUpperCase();
    }

    if (!regions.includes(region ?? '')) {
        region = regionDefault;
    }

    const dataLayer = window.dataLayer || [];
    dataLayer.push({ event: regionEvent, region: region });
    window.dataLayer = dataLayer;
}
